import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-coming-soon',
  standalone: false,
  templateUrl: './coming-soon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './coming-soon.component.css'
})
export class ComingSoonComponent {

}
